import React from 'react';

export const Spinner: React.FC<{ size?: 'sm' | 'md' | 'lg' }> = ({ size = 'md' }) => (
  <div className={`spinner spinner-${size}`} role="status" aria-label="Loading">
    <span className="sr-only">Loading...</span>
  </div>
);
